import {
  AtlassianNavigation,
  generateTheme,
  PrimaryButton,
  useOverflowStatus,
} from '@atlaskit/atlassian-navigation';
import { LinkItem } from '@atlaskit/menu';
import { B50, B100, N800 } from '@atlaskit/theme/colors';
import { LinkClickedEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { TabNames } from '@atlassian/mpac-partners';
import { useFeatureFlags, useHistory } from '@atlassian/mpac-ui';
import styled from '@emotion/styled';
import React from 'react';

import { ANALYTICS_EVENT_CONTAINER_PARTNER_QUICK_LINK } from '../../../../../../../../../analytics/Events';
import BootstrapConfig from '../../../../../../../../../bootstrapConfig';
import { usePartnerPermissions } from '../../../../../../../../../hooks/usePartnerPermissions';
import { getQuickLinkItems } from '../../utils/utils';

import type { PrimaryButtonProps } from '@atlaskit/atlassian-navigation';

const VendorName = styled.p<any>`
  padding-right: 20px;
  margin: 0;
  color: ${B50};
`;

const PartnerLinksTag = styled.p<any>`
  padding-left: 14px;
  padding-right: 10px;
  margin: 0;
  color: ${B50};
`;

const partnerQuickLinksTheme = generateTheme({
  name: 'partner-quick-links',
  backgroundColor: N800,
  highlightColor: B100,
});

type Props = {
  partnerId: number;
  partnerName: string;
};

export const NavigationButton = (props: PrimaryButtonProps) => {
  const { isVisible } = useOverflowStatus();
  return isVisible ? (
    <PrimaryButton {...props} />
  ) : (
    <LinkItem href={props.href}>{props.children}</LinkItem>
  );
};

const PartnerQuickLinksContent = (props: Props) => {
  const fireAnalyticsEvent = useAnalyticsEvents();
  const { useAmktFrontendAthreosManagePartners } = useFeatureFlags();
  const history = useHistory();
  const { mpacBaseUrl } = BootstrapConfig.get();

  const { permissions } = usePartnerPermissions(mpacBaseUrl, props.partnerId);

  const trackEventClick = (linkActionSubjectId: string) => {
    const eventAttributes = {
      partnerId: props.partnerId,
      partnerName: props.partnerName,
    };

    fireAnalyticsEvent({
      eventType: LinkClickedEvent,
      eventContainer: ANALYTICS_EVENT_CONTAINER_PARTNER_QUICK_LINK,
      actionSubjectId: linkActionSubjectId,
      attributes: { ...eventAttributes },
    });
  };

  const primaryItems = (
    items: Array<{
      linkActionSubjectId: string;
      name: string;
      path: string;
    }>
  ) =>
    items.map((item) => (
      <NavigationButton
        key={item.name}
        href={item.path}
        // @ts-expect-error [MC-2850] - TS2322 - Type '(event: Event) => void' is not assignable to type '(event: MouseEvent<HTMLElement, MouseEvent>, analyticsEvent: any) => void'.
        onClick={(event: Event) => onRouteClick(event, item)}
      >
        {item.name}
      </NavigationButton>
    ));

  if (!permissions) {
    return null;
  }

  const onRouteClick = (
    event: Event,
    navigationItem: {
      linkActionSubjectId: string;
      name: string;
      path: string;
    }
  ) => {
    if (
      (permissions.isSiteAdmin || useAmktFrontendAthreosManagePartners) &&
      navigationItem.name !== 'Announcements' &&
      navigationItem.name !== TabNames.REPORTS
    ) {
      event.preventDefault();
      // @ts-expect-error [MC-2850] - TS2532 - Object is possibly 'undefined'.
      history.push(navigationItem.path);
    }

    trackEventClick(navigationItem.linkActionSubjectId);
  };

  const quickLinkItems = getQuickLinkItems(permissions, props.partnerId);
  return (
    <AtlassianNavigation
      label="Quick Links Navigation"
      renderProductHome={() => <PartnerLinksTag>Partner Links: </PartnerLinksTag>}
      primaryItems={primaryItems(quickLinkItems)}
      theme={partnerQuickLinksTheme}
      renderProfile={() => <VendorName>{props.partnerName}</VendorName>}
    />
  );
};

export default PartnerQuickLinksContent;
